/* Powerbank-PDP: Galerie, Variantenlogik, Sticky-Kaufleiste.
   Kanonische Kaufquelle bleibt das Shopify-Produktformular (product-form.js). */
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function behavior() { return reduce.matches ? 'auto' : 'smooth'; }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initGallery(root) {
    var track = root.querySelector('[data-pb-track]');
    if (!track) return null;
    var slides = all('[data-pb-slide]', track);
    if (!slides.length) return null;
    var dots = all('[data-pb-dot]', root);
    var thumbs = all('[data-pb-thumb]', root);
    var thumbStrip = root.querySelector('[data-pb-thumbs]');
    var thumbShell = root.querySelector('[data-pb-thumbs-shell]');
    var thumbNav = all('[data-pb-thumb-scroll]', root);
    var counter = root.querySelector('[data-pb-counter]');
    var live = root.querySelector('[data-pb-gal-live]');
    var index = -1;
    var thumbRaf;

    function stripTo(left) {
      if (!thumbStrip) return;
      var max = Math.max(0, thumbStrip.scrollWidth - thumbStrip.clientWidth);
      left = Math.max(0, Math.min(max, left));
      if (typeof thumbStrip.scrollTo === 'function') {
        thumbStrip.scrollTo({ left: left, behavior: behavior() });
      } else {
        thumbStrip.scrollLeft = left;
      }
    }

    function thumbContentWidth() {
      if (!thumbStrip || !thumbs.length) return 0;
      var first = thumbs[0];
      var last = thumbs[thumbs.length - 1];
      var style = window.getComputedStyle ? window.getComputedStyle(thumbStrip) : null;
      var paddingLeft = style ? parseFloat(style.paddingLeft) || 0 : 0;
      var paddingRight = style ? parseFloat(style.paddingRight) || 0 : 0;
      return (last.offsetLeft - first.offsetLeft) + last.offsetWidth + paddingLeft + paddingRight;
    }

    function updateThumbNav() {
      if (!thumbStrip) return;
      var available = thumbShell ? thumbShell.clientWidth : thumbStrip.clientWidth;
      var scrollable = thumbContentWidth() > available + 2;
      if (thumbShell) thumbShell.classList.toggle('is-static', !scrollable);
      var max = Math.max(0, thumbStrip.scrollWidth - thumbStrip.clientWidth);
      thumbNav.forEach(function (button) {
        var previous = button.getAttribute('data-pb-thumb-scroll') === 'prev';
        button.disabled = !scrollable || (previous ? thumbStrip.scrollLeft <= 2 : thumbStrip.scrollLeft >= max - 2);
      });
    }

    function revealThumb(i) {
      if (!thumbStrip || !thumbs[i]) return;
      var thumb = thumbs[i];
      var stripRect = thumbStrip.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var left = thumbStrip.scrollLeft + (thumbRect.left - stripRect.left) -
        Math.max(0, (thumbStrip.clientWidth - thumb.offsetWidth) / 2);
      stripTo(left);
    }

    function set(i) {
      if (i === index) return;
      index = i;
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (live) live.textContent = 'Bild ' + (i + 1) + ' von ' + slides.length;
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
      revealThumb(i);
      updateThumbNav();
    }

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: smooth === false ? 'instant' : behavior() });
      } else {
        track.scrollLeft = left;
      }
      set(i);
    }

    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        if (!track.clientWidth) return;
        set(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))));
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'Home') { e.preventDefault(); go(0); }
      if (e.key === 'End') { e.preventDefault(); go(slides.length - 1); }
    });

    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); }); });
    thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { go(ti); }); });
    all('[data-pb-arrow]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        go(index + (button.getAttribute('data-pb-arrow') === 'next' ? 1 : -1));
      });
    });

    thumbNav.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!thumbStrip) return;
        var direction = button.getAttribute('data-pb-thumb-scroll') === 'next' ? 1 : -1;
        var step = Math.max(150, Math.round(thumbStrip.clientWidth * 0.72));
        stripTo(thumbStrip.scrollLeft + direction * step);
      });
    });

    if (thumbStrip) {
      thumbStrip.addEventListener('scroll', function () {
        window.cancelAnimationFrame(thumbRaf);
        thumbRaf = window.requestAnimationFrame(updateThumbNav);
      }, { passive: true });
      if ('ResizeObserver' in window) {
        var thumbObserver = new ResizeObserver(updateThumbNav);
        thumbObserver.observe(thumbStrip);
      } else {
        window.addEventListener('resize', updateThumbNav);
      }
    }

    set(0);
    window.requestAnimationFrame(updateThumbNav);
    return { go: go, index: function () { return index; } };
  }

  function init(root) {
    if (root.getAttribute('data-pb-ready') === '1') return;
    root.setAttribute('data-pb-ready', '1');

    var dataEl = root.querySelector('[data-pb-variants]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var gallery = initGallery(root);
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var inputs = all('[data-pb-option]', root);
    var qtyInput = form ? form.querySelector('[data-pb-qty-input]') : null;
    var qtyButtons = all('[data-pb-qty-action]', root);
    var quantity = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
    var currentVariant = null;
    var currency = root.getAttribute('data-pb-currency') || 'EUR';
    var locale = root.getAttribute('data-pb-locale') || document.documentElement.lang || 'de-DE';

    function formatMoney(cents) {
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return ''; }
    }

    function syncQuantity() {
      quantity = Math.max(1, Math.min(9, quantity));
      if (qtyInput) qtyInput.value = quantity;
      all('[data-pb-qty-value]', root).forEach(function (el) { el.textContent = quantity; });
      qtyButtons.forEach(function (btn) {
        var delta = Number(btn.getAttribute('data-pb-qty-action')) || 0;
        btn.disabled = (quantity === 1 && delta < 0) || (quantity === 9 && delta > 0);
      });
      if (currentVariant) {
        all('[data-pb-total]', root).forEach(function (el) {
          el.textContent = formatMoney(Number(currentVariant.price_raw) * quantity);
          el.hidden = !currentVariant.available;
        });
      }
    }

    qtyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        quantity += Number(btn.getAttribute('data-pb-qty-action')) || 0;
        syncQuantity();
      });
    });

    function selected() {
      var vals = [];
      inputs.forEach(function (i) { if (i.checked) vals[Number(i.getAttribute('data-pb-option'))] = i.value; });
      return vals;
    }
    function match(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (vals[j] && v.options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply(v, pushUrl) {
      if (!v) return;
      currentVariant = v;
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }

      all('[data-pb-price]').forEach(function (el) { el.innerHTML = v.price; });
      all('[data-pb-compare]').forEach(function (el) {
        el.innerHTML = v.compare || '';
        el.hidden = !v.compare;
      });
      all('[data-pb-save]').forEach(function (el) {
        el.textContent = v.save ? '\u2212' + v.save + '\u00A0%' : '';
        el.hidden = !v.save;
      });
      all('[data-pb-variant-label]', root).forEach(function (el) {
        var optionIndex = Number(el.getAttribute('data-pb-variant-label'));
        el.textContent = v.options[optionIndex] || v.title;
      });
      all('[data-pb-sticky-img]').forEach(function (el) { if (v.img) el.setAttribute('src', v.img); });

      all('[data-pb-avail]').forEach(function (el) {
        var t = el.querySelector('[data-pb-avail-text]');
        if (!t) return;
        if (!el.pbInText) {
          el.pbInText = (el.getAttribute('data-pb-avail') || '').trim() || t.textContent.trim();
        }
        var outText = (el.getAttribute('data-pb-avail-out') || '').trim() || el.pbInText;
        el.classList.toggle('pb-avail--out', !v.available);
        t.textContent = v.available ? el.pbInText : outText;
      });

      all('[data-pb-submit]', root).forEach(function (btn) {
        var span = btn.querySelector('[data-pb-button-label]') || btn.querySelector('span');
        if (span) span.textContent = v.available ? (btn.getAttribute('data-pb-add') || span.textContent) : (btn.getAttribute('data-pb-out') || span.textContent);
        if (v.available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
        else { btn.setAttribute('disabled', 'disabled'); }
      });

      syncQuantity();

      all('[data-pb-variant-note]').forEach(function (el) {
        var list = (el.getAttribute('data-pb-variant-note') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
        el.hidden = list.length ? list.indexOf(v.title) === -1 : false;
      });

      inputs.forEach(function (i) {
        var vals = selected();
        vals[Number(i.getAttribute('data-pb-option'))] = i.value;
        var cand = match(vals);
        var wrap = i.parentElement;
        if (wrap) wrap.classList.toggle('pb-sw--off', !(cand && cand.available));
      });

      if (gallery && typeof v.media === 'number' && v.media > -1 && v.media !== gallery.index()) gallery.go(v.media, false);

      if (pushUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* ignore */ }
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { apply(match(selected()), true); });
    });
    if (variants.length) apply(match(selected()), false);

    /* Sticky-Kaufleiste: erscheint erst, wenn der Haupt-Kaufbutton nach oben rausgescrollt ist. */
    var bar = root.querySelector('[data-pb-sticky]');
    var anchor = root.querySelector('[data-pb-anchor]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(anchor);
    }

    /* Lade-/Erfolgszustand fuer Buttons, die per form-Attribut auf das Produktformular verweisen. */
    if (form) {
      var timer;
      form.addEventListener('submit', function () {
        all('[data-pb-submit][form]').forEach(function (btn) {
          var span = btn.querySelector('[data-pb-button-label]') || btn.querySelector('span');
          if (span) span.textContent = btn.getAttribute('data-pb-loading') || 'Wird hinzugef\u00fcgt \u2026';
          btn.setAttribute('aria-disabled', 'true');
        });
      });
      var done = function (state) {
        window.clearTimeout(timer);
        all('[data-pb-submit]').forEach(function (btn) {
          var span = btn.querySelector('[data-pb-button-label]') || btn.querySelector('span');
          if (span) span.textContent = state === 'ok' ? (btn.getAttribute('data-pb-done') || 'Im Warenkorb') : (btn.getAttribute('data-pb-add') || span.textContent);
          btn.removeAttribute('aria-disabled');
        });
        timer = window.setTimeout(function () {
          all('[data-pb-submit]').forEach(function (btn) {
            var span = btn.querySelector('[data-pb-button-label]') || btn.querySelector('span');
            if (span) span.textContent = btn.getAttribute('data-pb-add') || span.textContent;
          });
        }, 1800);
      };
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function () { done('ok'); });
          subscribe(PUB_SUB_EVENTS.cartError, function () { done('err'); });
        }
      } catch (e) { /* ignore */ }
    }
  }

  function boot(scope) { all('[data-pb-product]', scope || document).forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

